import React, { ReactNode } from "react";
import classnames from "classnames";

import "./index.scss";

export interface FieldPreviewProps {
  className?: string;
  label?: string | null;
  value?: ReactNode | string | number;
  tooltip?: string;
}

export default function FieldPreview(props: FieldPreviewProps) {
  const { className, label, value, tooltip } = props;
  return (
    <div className={classnames("field-preview", className)}>
      {label ? <div className="field-preview-label">{label}</div> : null}
      {value ? (
        <div title={tooltip} className="field-preview-value">
          {value}
        </div>
      ) : null}
    </div>
  );
}
